<template>
  <div>
    <van-swipe class="swipe" :height="swipeHeight" :autoplay="5000" @change="onChange">
      <van-swipe-item v-for="(item, index) of floor.items" :key="item.id">
        <div class="image-box" @click="onNavigateTo(item, index)">
          <img class="image" :src="item.pageImgUrl" />
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { navigateTo } from '@/views/activities/utils'
import utils from '@/utils/common'
export default {
  props: {
    floor: Object,
    home: Object
  },
  data() {
    return {
      swipeHeight: 'auto'
    }
  },
  watch: {
    floor: {
      immediate: true,
      handler() {
        const { floor } = this;
        const heights = floor.items.map(item => {
          return utils.computeImageViewHeight(
            item.pageImgWidth,
            item.pageImgHeight,
            floor.$viewWidth
          )
        });
        this.swipeHeight = Math.max.apply(null, heights)
      }
    }
  },
  created() {
    this.uploadGio()
  },
  methods: {
    onNavigateTo(item, index) {
      this.uploadClickGio(item, index)
      navigateTo(this, item)
    },
    uploadClickGio(item, index) {
      const { home, floor } = this

      let type, value;
      switch (floor.goodsLinkType) {
        case 1: // 商品详情页
          type = 3;
          value = item.refId;
          break;
        case 2: // 二级页面
          type = 11;
          value = floor.goodsLinkValue;
          break;
        case 3: // 店铺主页
          type = 4;
          value = item.branchNo;
          break;
        case 4: // 品牌首页
          type = 10;
          value = item.logoId;
          break;
        case 5: // 商品详情落地页
          type = 53;
          value = item.refId;
          break;
        case 6: // 店铺主页落地页
          type = 54;
          value = item.branchNo;
          break;
      }

      const shared = {
        pageType_var: home.$pageName,
        dataSourceType_var: item.goodsLinkType,
        secondPageID_var: home.contentPageId||"",   //ver607埋点:secondPageID_var修改
        dataSourcePageID_var: value,
      };

      const data = {
        pageType_var: home.$pageName,
        indexId_var: home.contentPageId,
        entryType_vara: 'banner',
        entryType_floor_var: floor.$index,
        position_var: index + 1,
        sort_var: item.lineSort,
        positionName_var: item.name //gio名称
      }
      switch(home.$from) {
        case 'home':
          gio('track','flowLocationClick', data)
          gio('setEvar', 'module_evar', 'banner')
          break;
        case 'activity':
        case 'goods-landing':
        case 'store-landing':
          data.secondPageID_var = home.contentPageId
          //ver607 二级页面流量位点击
          data["belongShop_var"]='n';  //归属商场ID
          // data["belongShop_var"]=item&&item.shopId||'n';  //归属商场ID
          data["shopID_var"]='n';  //切换商场ID
          let curData=  {...data,...shared};
          gio('track','activityFlowLocationClick_var', curData)
          break;
      }
    },
    uploadGio() {
      const { home, floor } = this;
      //ver607  首页曝光
      if(home&&home.$from =="home"){
        gio('track','moduleExposure',{
          pageType_var: home.$pageName,
          indexId_var: home.contentPageId,
          entryType_vara: 'banner',
          entryType_floor_var: floor.$index,
        });
      }
    },
    onChange(current) {
      this.uploadChangeGio(current)
    },
    uploadChangeGio(current) {
      const { home, floor } = this
      const item = floor.items[current]
      if(item.show) return;
      item.show = true
      const data = {
        pageType_var: home.$pageName,
        indexId_var: home.contentPageId,
        entryType_vara: 'banner',
        entryType_floor_var: current + 1,
      }
      switch(home.$from) {
        case 'home':
          gio('track','moduleExposure',data)
          break;
        case 'activity':
        case 'goods-landing':
        case 'store-landing':  
          //ver607二级页面曝光
          data["belongShop_var"]='n';  //归属商场ID
          // data["belongShop_var"]=item&&item.shopId||'n';  //归属商场ID
          data["shopID_var"]='n';  //切换商场ID

          gio('track','moduleExpore_var',data)
          break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.swipe /deep/.van-swipe__track {
  align-items: center;
}
.swipe {
  border-radius: 20px;
  overflow: hidden;
  /deep/.van-swipe__indicators {
    bottom: 10px;
  }
  /deep/.van-swipe__indicator {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.2);
    margin-right: 10px;
  }
  /deep/.van-swipe__indicator--active {
    background: rgba(255, 255, 255, 0.7);
  }
}
.image-box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.image {
  width: 100%;
}
</style>
